import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Form,
  Loader,
  Container,
  Content,
  Checkbox,
  Modal,
} from "rsuite";
import { MusicScheduleServices } from "../../../core/services/MusicScheduleServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./MusicSchedules.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  displayDateField,
  displayDateTimeField,
  displayField,
  displayTimeField,
  isEmptyVal,
} from "../../../utils/helpers";

const ViewProfileModal = (props: any) => {
  const { t } = useTranslation();
  const musicScheduleId = useSelector((state: any) => {
    return state?.actionData?.id;
  });
  const [loader, setLoader] = useState(false);
  const [musicScheduleInfo, setMusicScheduleInfo] = useState<any>({});
  const [address, setAddress] = useState<any>({});
  async function getViewMusicScheduleDetail(id: number) {
    try {
      setLoader(true);
      const res = await MusicScheduleServices.viewMusicSchedule(id);
      setLoader(false);
      if (res && res.data && res.data.data) {
        setMusicScheduleInfo({ ...res.data.data });
      }
    } catch (error) {
      setLoader(false);
    }
  }
  useEffect(() => {
    getViewMusicScheduleDetail(musicScheduleId);
  }, []);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={props.status}
        backdrop={false}
        onClose={(e: any) => {
          props.toggle("");
        }}
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("VIEW")} {t("MUSIC_SCHEDULE")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="music-schedules view-music-schedules">
            <Container className="container">
              {musicScheduleInfo && Object.keys(musicScheduleInfo).length ? (
                <Content>
                  <Form layout="inline">
                    <Form.Group controlId="name">
                      <Form.ControlLabel>{t("NAME")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${musicScheduleInfo?.playlist_title}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="total_songs">
                      <Form.ControlLabel>
                        {t("TOTAL")} {t("SONGS")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${
                            isEmptyVal(musicScheduleInfo?.total_songs)
                              ? 0
                              : musicScheduleInfo?.total_songs
                          }`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="max_songs">
                      <Form.ControlLabel>
                        {t("MAX")} {t("SONGS")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${musicScheduleInfo?.max_songs}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="company">
                      <Form.ControlLabel>{t("COMPANY")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${musicScheduleInfo?.company?.comp_name}`
                        )}{" "}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="region_name">
                      <Form.ControlLabel>{t("REGION")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${musicScheduleInfo?.store_group?.region?.region_name}`
                        )}{" "}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="store_group">
                      <Form.ControlLabel>
                        {t("STORE")} {t("GROUP")}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${musicScheduleInfo?.store_group?.group_name}`
                        )}{" "}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="is_default_playlist">
                      <Form.ControlLabel>
                        {t("DEFAULT")} {t("SCHEDULE")}{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {musicScheduleInfo?.is_default_playlist == "1"
                          ? t("YES")
                          : t("NO")}
                      </Form.ControlLabel>
                    </Form.Group>
                    {musicScheduleInfo?.is_default_playlist.toString() ===
                      "0" && (
                      <>
                        <Form.Group controlId="duration">
                          <Form.ControlLabel>
                            {t("PLAY")} {t("START")} {t("DATE")}
                          </Form.ControlLabel>
                          <Form.ControlLabel>
                            {displayDateField(
                              musicScheduleInfo?.play_start_date
                            )}
                          </Form.ControlLabel>
                        </Form.Group>
                        <Form.Group controlId="duration">
                          <Form.ControlLabel>
                            {t("PLAY")} {t("END")} {t("DATE")}
                          </Form.ControlLabel>
                          <Form.ControlLabel>
                            {displayDateField(musicScheduleInfo?.play_end_date)}
                          </Form.ControlLabel>
                        </Form.Group>
                      </>
                    )}

                    <Form.Group controlId="new_schedule_everyday">
                      <Form.ControlLabel>
                        {t("NEW")} {t("SCHEDULE")} {t("DAILY")}{" "}
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {musicScheduleInfo?.new_schedule_everyday.toString() ===
                        "1"
                          ? t("YES")
                          : t("NO")}
                      </Form.ControlLabel>
                    </Form.Group>

                    <Form.Group controlId="day_parts">
                      <Form.ControlLabel>{t("DAY_PARTS")}</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${musicScheduleInfo?.day_parts}`)}
                      </Form.ControlLabel>
                    </Form.Group>

                    {musicScheduleInfo?.time_slots?.map((item: any) => (
                      <Form.Group>
                        <Form.ControlLabel>
                          {item.slot_title} (
                          {displayField(item.start_hour) +
                            " " +
                            t("TO") +
                            " " +
                            displayField(item.end_hour)}
                          )
                        </Form.ControlLabel>
                        <Form.ControlLabel>
                          {displayField(
                            `${
                              isEmptyVal(item?.total_songs)
                                ? 0
                                : item?.total_songs
                            }`
                          )}{" "}
                          {t("SONGS")}
                        </Form.ControlLabel>
                      </Form.Group>
                    ))}
                  </Form>
                </Content>
              ) : null}
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewProfileModal;
